import { render, staticRenderFns } from "./tranCus.vue?vue&type=template&id=341a4fd3&scoped=true&"
import script from "./tranCus.vue?vue&type=script&lang=js&"
export * from "./tranCus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341a4fd3",
  null
  
)

export default component.exports